"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEmbeddedService = void 0;
const post_service_1 = require("./post-service");
const embedded_service_1 = require("./embedded-service");
const createEmbeddedService = () => __awaiter(void 0, void 0, void 0, function* () {
    const srv = new embedded_service_1.EmbeddedService(new post_service_1.PostService());
    yield srv.initialize();
    return srv;
});
exports.createEmbeddedService = createEmbeddedService;
